import React, {useState} from 'react'
import TextForm from './TextForm'
import PropTypes from 'prop-types'

export default function About(props) {

    // const [myStyle, setmyStyle] = useState({
    //     color:'black',
    //     backgroundColor:'white',
    // })

//     const [btnText, setbtnText] = useState('Enable Light Mode')

//    const toggleStyle = () =>{
//         if(myStyle.color === 'white'){
//             setmyStyle({
//                 color:'black',
//                 backgroundColor:'white', 
//             })
//             setbtnText("Enable Dark Mode")
//         }
//         else{
//             setmyStyle({
//                 color:'white',
//         backgroundColor:'black',
//             })
//             setbtnText("Enable Light Mode")
//         }
//     }

let myStyle ={
    color:props.mode === 'dark'?'white':'#165689',
    backgroundColor: props.mode === 'dark'?'#165689':'white'
}
  return (
    <div className='container' style={{color:props.mode === 'dark'?'white':'#042743'}}>
        <p  >Welcome to Jambh Bhakti - Word Counter, your one-stop destination for all your text analysis needs. We are a team of experienced developers and language enthusiasts who have come together to create a user-friendly tool that can help you quickly and accurately measure the length and quality of your writing.

        Our mission is to provide a simple and efficient solution for anyone looking to improve their writing, streamline their editing process, or just get a quick word count. We believe that the power of words is limitless and that with the right tools, anyone can take their writing to the next level.

        With Jambh Bhakti - Word Counter, you'll find a suite of powerful features that make text analysis a breeze. Whether you're counting words, characters, or gauging reading time, our tools provide fast and accurate results. You can also easily convert text to uppercase or lowercase, copy, remove extra spaces, or clear your text with just a few clicks.

        We are dedicated to providing the best user experience possible and are constantly working to improve our website and add new features. If you have any feedback or suggestions, we'd love to hear from you.

        Thank you for choosing Jambh Bhakti - Word Counter, and we look forward to helping you take your writing to the next level.</p>
        <h2 className='container my-3'>FAQs</h2>
        <div className="accordion" id="accordionExample" >
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                What is Jambh Bhakti - Word Counter?
                </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                Jambh Bhakti - Word Counter is a text analysis tool that allows you to measure the length and quality of your writing. With our tools, you can count words, characters, and calculate reading time, as well as convert text to uppercase or lowercase, copy, remove extra spaces, and clear your text.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                How accurate is the word count tool?
                </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                Our word count tool is highly accurate and is designed to provide fast and reliable results.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Can I convert text to uppercase or lowercase with Jambh Bhakti - Word Counter?
                </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                    Yes, you can easily convert text to uppercase or lowercase using our text conversion tool.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingfour">
                <button className="accordion-button collapsed" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                Can I remove extra spaces from my text using Jambh Bhakti - Word Counter?
                </button>
                </h2>
                <div id="collapsefour" className="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                Yes, our text editing tool allows you to remove extra spaces with just a few clicks.
                </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingfive">
                <button className="accordion-button collapsed" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                Is there a limit to the amount of text I can analyze with Jambh Bhakti - Word Counter?
                </button>
                </h2>
                <div id="collapsefive" className="accordion-collapse collapse" aria-labelledby="headingfive" data-bs-parent="#accordionExample">
                <div className="accordion-body" style={myStyle}>
                No, there is no limit to the amount of text you can analyze with our website. You can use it as much as you need.
                </div>
                </div>
            </div>
        </div>
        {/* <div className="conateiner my-3">
            <button className="btn btn-primary" onClick={toggleStyle}>{btnText}</button>
        </div> */}
    </div>
  )
}